import { PageOptions } from '@graphcommerce/framer-next-pages'
import { ApolloError, useApolloClient } from '@graphcommerce/graphql'
import {
  ApolloCustomerErrorAlert,
  CustomerDocument,
  SignInDocument,
} from '@graphcommerce/magento-customer'
import { graphqlErrorByCategory } from '@graphcommerce/magento-graphql'
import { StoreConfigDocument } from '@graphcommerce/magento-store'
import { FormActions } from '@graphcommerce/next-ui'
// eslint-disable-next-line import/no-extraneous-dependencies
import { emailPattern, useFormGqlMutation } from '@graphcommerce/react-hook-form'
import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { GraphQLError } from 'graphql'
import { GetStaticProps } from 'next'
import router from 'next/router'
import { useContext, useEffect, useState } from 'react'
import { LayoutDocument, LayoutNavigation, LayoutNavigationProps } from '../../components'
import { Button } from '../../components/Button'
import { ForgotPasswordForm } from '../../components/Customer/ForgotPasswordForm/ForgotPasswordForm'
import { SignInSocial } from '../../components/Customer/SignInSocial/SignInSocial'
import { MegaMenuEditor } from '../../components/Header/MegaMenuEditor'
import { Icon } from '../../components/Layout/Icon'
import { SlideinModalHeader } from '../../components/Layout/SlideinModalHeader'
import { Message } from '../../components/Message'
import { globalContext } from '../../components/NextUi/globalContext'
import { TextInput } from '../../components/TextInput'
import { graphqlSharedClient, graphqlSsrClient } from '../../lib/graphql/graphqlSsrClient'

type GetPageStaticProps = GetStaticProps<LayoutNavigationProps>

export function DashboardPage() {
  return <MegaMenuEditor />
}

const pageOptions: PageOptions<LayoutNavigationProps> = {
  Layout: LayoutNavigation,
}
DashboardPage.pageOptions = pageOptions

export default DashboardPage

export const getStaticProps: GetPageStaticProps = async ({ locale }) => {
  const staticClient = graphqlSsrClient(locale)
  const client = graphqlSharedClient(locale)
  const conf = client.query({ query: StoreConfigDocument })
  const layout = staticClient.query({ query: LayoutDocument, fetchPolicy: 'cache-first' })

  return {
    props: {
      ...(await layout).data,
      up: { href: '/', title: 'Home' },
      apolloState: await conf.then(() => client.cache.extract()),
    },
    revalidate: process.env.SKIP_ISG ? 1 : 60 * 20,
  }
}
